module.exports = __webpack_public_path__ + "static/media/见微1218-彩钢公寓.1c2ef5a6.pdf";